import { getResponsiveProp } from '..';
import { rem, responsive } from '../helpers';
function toBoxShadow(shadow, color) {
    return `${shadow.map(rem).join(' ')} ${color}`;
}
function shadowStyle(shadow) {
    if (!shadow)
        return {};
    const outline = `0 0 0 ${rem(1)} var(--card-shadow-outline-color)`;
    const umbra = toBoxShadow(shadow.umbra, 'var(--card-shadow-umbra-color)');
    const penumbra = toBoxShadow(shadow.penumbra, 'var(--card-shadow-penumbra-color)');
    const ambient = toBoxShadow(shadow.ambient, 'var(--card-shadow-ambient-color)');
    return { boxShadow: `${outline}, ${umbra}, ${penumbra}, ${ambient}` };
}
export function responsiveShadowStyle(props) {
    const { theme } = props;
    const { media, shadows } = theme.sanity;
    return responsive(media, getResponsiveProp(props.$shadow), (shadow) => shadowStyle(shadows[shadow]));
}
//# sourceMappingURL=shadowStyle.js.map